var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgJournal(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "journal-text_1_",
    "data-name": "journal-text (1)",
    xmlns: "http://www.w3.org/2000/svg",
    width: 52.928,
    height: 56.456,
    viewBox: "0 0 52.928 56.456",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2485",
    "data-name": "Trazado 2485",
    d: "M5,26.935a1.764,1.764,0,0,1,1.764-1.764h7.057a1.764,1.764,0,0,1,0,3.529H6.764A1.764,1.764,0,0,1,5,26.935Zm0-7.057a1.764,1.764,0,0,1,1.764-1.764H24.407a1.764,1.764,0,1,1,0,3.529H6.764A1.764,1.764,0,0,1,5,19.878Zm0-7.057a1.764,1.764,0,0,1,1.764-1.764H24.407a1.764,1.764,0,1,1,0,3.529H6.764A1.764,1.764,0,0,1,5,12.821ZM5,5.764A1.764,1.764,0,0,1,6.764,4H24.407a1.764,1.764,0,1,1,0,3.529H6.764A1.764,1.764,0,0,1,5,5.764Z",
    transform: "translate(12.643 10.114)",
    fill: "#003082"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2486",
    "data-name": "Trazado 2486",
    d: "M8.057,0H43.342A7.057,7.057,0,0,1,50.4,7.057V49.4a7.057,7.057,0,0,1-7.057,7.057H8.057A7.057,7.057,0,0,1,1,49.4V45.871H4.529V49.4a3.529,3.529,0,0,0,3.529,3.529H43.342A3.529,3.529,0,0,0,46.871,49.4V7.057a3.529,3.529,0,0,0-3.529-3.529H8.057A3.529,3.529,0,0,0,4.529,7.057v3.529H1V7.057A7.057,7.057,0,0,1,8.057,0Z",
    transform: "translate(2.529)",
    fill: "#003082"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Trazado_2487",
    "data-name": "Trazado 2487",
    d: "M3.529,7.529V5.764a1.764,1.764,0,1,1,3.529,0V7.529H8.821a1.764,1.764,0,1,1,0,3.529H1.764a1.764,1.764,0,0,1,0-3.529Zm0,10.586V16.35a1.764,1.764,0,1,1,3.529,0v1.764H8.821a1.764,1.764,0,1,1,0,3.529H1.764a1.764,1.764,0,1,1,0-3.529Zm0,10.586V26.935a1.764,1.764,0,1,1,3.529,0V28.7H8.821a1.764,1.764,0,0,1,0,3.529H1.764a1.764,1.764,0,0,1,0-3.529Z",
    transform: "translate(0 10.114)",
    fill: "#003082"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgJournal);
export default __webpack_public_path__ + "static/media/journal.19264f2cb52c61692a7a0d39cfafb539.svg";
export { ForwardRef as ReactComponent };